// @flow

import _ from 'lodash';
import I18n from '../i18n/I18n';

import ApiConstants from '../constants/ApiConstants';

export default class RestaurantTagsList {

  /**
   * Returns a list of countries for the choice picker.
   * Use the name as label and the alpha2 as value.
   * Used by CountryActionChoose
   */
  static getTagsListForPicker() {
    const list = [];
    _.each(ApiConstants.RestaurantTag, (tag) => {
      list.push(
        {
          label: I18n.tr(tag),
          value: I18n.tr(tag)
        }
      );
    });

    return list;
  }

}
